
import * as Accountant from 'app/calcs/Accountant'
import * as TX from 'app/calcs/Accountant/Transactions/interfaces'
import { IIOPensionInputs } from 'app/calcs/customers/IO/interfaces'
import { CommonPensionCalculations } from 'app/calcs/pensions'
import { ICommonPensionInputs, IMonthlyPensionPayments, SimplePensionFormOfPayment } from 'app/calcs/pensions/interfaces'
import { cachedIORunCalculations } from 'app/redux/Customers/IO/actions'
import { ageAtAsDuration, deadBy, IRetirementPerson, Profile } from 'app/redux/Profile/model'
import * as utils from 'app/utils'
import { makeIOPaymentExtractor } from 'app/workbookDAOs/IODAO'
import * as _ from 'lodash'
import * as moment from 'moment'

class IOPensionCalculations extends CommonPensionCalculations<IIOPensionInputs> {

  protected spouse: IRetirementPerson

  constructor(profile: Profile, pensionText: string) {
    super(profile, pensionText)
  }

  getMonthlyPensionAmount(member: IRetirementPerson, vals: IIOPensionInputs, when: moment.Moment): Promise<IMonthlyPensionPayments> {
    if (!vals.participatesInIO) {
      return Promise.resolve({
        beginPaymentsAge: vals.beginPaymentsAge,
        amount: 0,
        kind: vals.formOfPayment,
        totalLumpSum: 0,
        totalVestingService: 0,
        totalPensionCredits: 0
      })
    }
    const spouse = this.spouse
    return cachedIORunCalculations({ member, spouse, vals })
      .then(makeIOPaymentExtractor(vals, when))
      .then((baseAmount) => {
        // tslint:disable-next-line:no-console
        //console.log('IO amount at ' + when.format('L') + ' is ' + amount + ', vals: ' + JSON.stringify(vals))
        const kind = vals.formOfPayment as SimplePensionFormOfPayment
        return this.calculateSimplePension(when, baseAmount, kind, false)
      })
  }

  getPension(): IIOPensionInputs {
    return this.profile.pension.IO
  }

  getPerson(): IRetirementPerson {
    return this.profile.getHeadOfHousehold()
  }

  getTimeLineTransactions(): Promise<TX.ITransactionItem[]> {
    this.setSpouse(this.profile.getSpouse())
    return super.getTimeLineTransactions()
  }

  getTransactions(when: moment.Moment, tolerance: TX.TransactionTolerance = 'month'): Promise<TX.ITransactionItem[]> {
    this.setSpouse(this.profile.getSpouse())
    return super.getTransactions(when, tolerance)
  }

  setSpouse(spouse: IRetirementPerson) {
    this.spouse = spouse
  }
}

export {
  IOPensionCalculations
}



// WEBPACK FOOTER //
// ./src/app/calcs/customers/IO/index.ts